import React from 'react';
import { MyFreeGiftToYouContainer } from './MyFreeGiftToYou.styles';
import LinkBranded from 'src/elements/links/2023_Q4/LinkBranded';
import { palette } from 'src/styles/colors';
import Paragraph from 'src/elements/typography/paragraph';

const MyFreeGiftToYou = (): JSX.Element => (
  <MyFreeGiftToYouContainer>
    <Paragraph
      text='MY FREE GIFT TO YOU  ⎯ a 14-day free trial to Mighty Networks'
      standardSize='1.125'
      align='left'
      weight={400}
    />
    <LinkBranded
      text='Start Your FREE Mighty Networks Trial'
      standardSize='1.125'
      colorScheme='Black'
      url='https://cohost.mn.co/?plan=free-trial'
      customBorderColor={palette.black}
      customBorderRadius={36}
    />
  </MyFreeGiftToYouContainer>
);

export default MyFreeGiftToYou;
